

angular.module('admin')
.directive('widgetMultiDictionary', function() {
    return {
    	templateUrl: 'partials/fields/widget-multi-dictionary.html',
    	scope: {
    		dictionary: '=',
    	},
    	require: 'ngModel',
    	bindToController: true,
    	link: function (scope, elem, attrs, ngModel) {
			var ctrl = scope.widget; //add this 
			ctrl.modelCtrl = ngModel; 
			ctrl.init()
		},
    	controller: function($scope, $translate) {
    		var self = this;
    		
    		this.pairs = [];
    		this.values = [];
    		this.init = function() {
    			self.modelCtrl.$isEmpty = function(val) {
					return val == null || (val.length == 0);
				};
				self.modelCtrl.$render = function() {
					if (!self.modelCtrl.$modelValue) {
						self.values = [];
					}
					self.values = self.modelCtrl.$modelValue
				};
    		}
    		
    		$scope.$watchCollection(function(){return self.dictionary},function(){
    			self.pairs.length = 0;
    			if (!self.dictionary) return;
    			if (self.dictionary.length) {
    				for (var i in self.dictionary) {
    					var item = self.dictionary[i];
    					if (item.length == 2) {
    						self.pairs.push(item);
    					}
    					if (item.__id) {
    						self.pairs.push([item.__id, item.__title]);
    					}
    				}
    			} else {
    				for (var key in self.dictionary) {
    					self.pairs.push([key, self.dictionary[key]]);
    				}
    			}
    		})
			
			// field.dictionary może mieć postać {a: "b"} lub [["a","b"]]. 
			// Potrzebujemy tą pierwszą do przerabiania value => title w widokach.
			this.dictionaryAsMap = function(dict) {
				if (dict.length) {
					var ret = {};
					for (var i=0; i<dict.length; i++) {
						ret[dict[i][0]] = dict[i][1];
					}
					return ret;
				} else {
					return dict;
				}
			}
			
			this.titleForKey = function(key) {
				var dict = self.dictionaryAsMap(self.pairs);
				if (typeof key == "string" || typeof key == "number") {
					return dict[key];
				} else {
					var titles = [];
					for (var i=0; i<key.length; i++) {
						titles.push(dict[key[i]]);
					}
					return titles.join(', ');
				}
			}
			
			this.toggleOption = function(option) {
				var pos = self.values.indexOf(option);
				if (pos >= 0) {
					self.values.splice(pos,1);
				} else {
					self.values.push(option);
				}
				self.modelCtrl.$setViewValue(self.values);
				self.modelCtrl.$setDirty();
				return self.values;
			}
			
			this.clear = function() {
				self.values = self.values || [];
				self.values.length = 0;
				self.modelCtrl.$setViewValue(self.values);
				self.modelCtrl.$setDirty();
			}
			
			this.hasOption = function(option) {
				return (self.values||[]).indexOf(option) >= 0;
			}

    		
    		
    	},
    	controllerAs: 'widget',
    }
})